<template>
  <div class="d-flex justify-content-center mt-3">
    <nav class="pagination-custom">
            <div class="page-item disabled">
                <img class="control" :class="{ 'rotate-180':  this.$i18n.locale  === 'en' }" src="@/assets/images/home/advocacypillar/right-arrow.png" alt="Right Arrow">
            </div>
            <span class="dot active">•</span>
            <span class="dot">•</span>
            <span class="dot">•</span>

            <div class="page-item active">
                <img class="control" :class="{ 'rotate-180':  this.$i18n.locale  === 'en' }" src="@/assets/images/home/advocacypillar/left-arrow.png" alt="Left Arrow">

            </div>
        </nav>
  </div>
</template>

<style scoped>
.carousel-controls {
  text-align: center;
  margin-top: 10px;
}

.pagination-custom {
  display: flex;
  align-items: center;
}

.page-item {
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.page-item.active {
  background-color: #c49a3a;
  /* Gold */
  border: none;
  color: white;
}

.page-item.disabled {
  background-color: #f8f5eb;
  /* Light beige */
  border: none;
  color: #d1c4a8;
}

.dot {
  color: #edeade;
  margin: 0 10px;
  font-size: 24px;
}

.dot.active {
  color: #bf9f35;
}
.control {
  height: 12px;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
